// Phase 15 M2 — Sanitary semáforo pill, reusable across detail page tabs.
//
// `level` follows the existing mobile convention used in
// mobile/src/screens/SanitaryView: green = up to date, amber = needs review
// soon, red = blocked (active sanitary restriction). Unknown stays neutral.

export type SanitaryLevel = 'GREEN' | 'AMBER' | 'RED' | 'UNKNOWN';

interface Props {
  level: SanitaryLevel;
  label?: string;
}

const STYLES: Record<
  SanitaryLevel,
  { bg: string; text: string; emoji: string; defaultLabel: string }
> = {
  GREEN: { bg: 'bg-chain-soft', text: 'text-chain', emoji: '✓', defaultLabel: 'Sanitario ao día' },
  AMBER: {
    bg: 'bg-yellow-50',
    text: 'text-warning',
    emoji: '!',
    defaultLabel: 'Revisión pendente',
  },
  RED: { bg: 'bg-red-50', text: 'text-danger', emoji: '⚠', defaultLabel: 'Restrición activa' },
  UNKNOWN: { bg: 'bg-border/40', text: 'text-muted', emoji: '?', defaultLabel: 'Sen datos' },
};

export default function SanitaryIndicator({ level, label }: Props): JSX.Element {
  const s = STYLES[level];
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${s.bg} ${s.text}`}
    >
      <span aria-hidden>{s.emoji}</span>
      <span>{label ?? s.defaultLabel}</span>
    </span>
  );
}
